import { Dropdown as DropdownComp, DropdownProps, Space } from 'antd';
import { useEffect, useState } from 'react';

import { CaretDownDark } from '../../icons';
import { handleKeyboardClick } from '../../utils';
import { getClassName } from '../_utils';

import './Dropdown.scss';

type Props = Pick<
  DropdownProps,
  | 'menu'
  | 'disabled'
  | 'className'
  | 'overlayClassName'
  | 'overlayStyle'
  | 'placement'
  | 'popupRender'
  | 'trigger'
> & {
  ariaLabel?: string;
  icon?: React.ReactNode;
  label?: string;
};

type LabeledProps = Props & {
  children?: undefined;
  label: string;
};

type UnlabeledProps = Props & {
  ariaLabel: string;
  children: React.ReactNode;
  label?: undefined;
};

/**
 * returns JSX for dropdown
 */
export function Dropdown({
  ariaLabel,
  className = 'secondary',
  children,
  icon,
  label,
  ...props
}: LabeledProps | UnlabeledProps) {
  const [dropdownOpen, setDropdownOpen] = useState<boolean>(false);
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'hidden') {
        setDropdownOpen(false);
      }
    };
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);
  const content = children ? children : label;

  return (
    <DropdownComp
      {...props}
      className={getClassName('dropdown', className)}
      onOpenChange={(visible) => setDropdownOpen(visible)}
      open={dropdownOpen}
    >
      <Space
        aria-label={ariaLabel || label}
        tabIndex={0}
        role="button"
        onKeyDown={(e) => {
          handleKeyboardClick(e);
        }}
      >
        {content}
        {icon === undefined ? <CaretDownDark /> : icon}
      </Space>
    </DropdownComp>
  );
}
